$ = require 'jquery'

module.exports = 
  (->
    $(document).ready ->
      #jobsSlideshow();
      mobileMenuCheck()
      mobileMenuClickHandler()
      return

    $(window).resize ->
      mobileMenuCheck()
      return
    
    #Resize headline background-image to allow a height proportional to the browser width
    jobsSlideshow = jobsSlideshow = ->
      interval = 5000
      job = $(".job")
      job.hide()
      jobNumber =
        0: $(".job0")
        1: $(".job1")
        2: $(".job2")
        3: $(".job3")
        4: $(".job4")

      jobNumber[0].fadeIn()
      j = 0
      setInterval (->
        job.fadeOut().promise().then ->
          j += 1
          if j > 4
            j = 0
          else

          
          #jobNumber[j].fadeIn();
          jobNumber[j].fadeIn()
          return

        return
      ), interval
      return

    mobileMenuClickHandler = mobileMenuClickHandler = ->
      $(".nav, section, footer").click (e) ->
        navLinks = $(".nav-links")
        clickTarget = e.target.className
        
        #Open Mobile Menu if nav menu button is clicked
        if clickTarget is "nav-mobile-button"
          unless navLinks.hasClass("active")
            navLinks.addClass "active"
          else
            navLinks.removeClass "active"
        
        #Close Mobile Menu if anything else is clicked
        else
          navLinks.removeClass "active"  if navLinks.hasClass("active")
        return

      return

    mobileMenuCheck = showMobileMenu = ->      
      #Show Mobile Menu
      if window.innerWidth < 768
        $(".nav-links").addClass "mobile"
      else
        $(".nav-links").removeClass "mobile"
      return

    return

  )()